import { insertEmbed, getNodeAttrs, setActiveTool } from "../../../commands/custom-commands";
import { customSchema } from "../../../schemas/custom-schema";
import { menuPluginKey } from "../menu-plugin";

export default class EmbedTool {
  constructor(editorView, containerElement) {
    this.view = editorView;
    this.buildContainer();
    this.buildDialog();
    this.bindActions();
    containerElement.appendChild(this.containerElement);
    this.update(editorView);
  }

  buildContainer() {
    this.containerElement = document.createElement("div");
    this.containerElement.className = "editor-button-container";
    this.buttonElement = document.createElement("button");
    this.buttonElement.setAttribute("type", "button");
    this.buttonElement.className = "editor-toolbar-button";
    this.buttonElement.style.anchorName = "--embed-anchor";
    this.buttonElement.dataset.action = "embed";
    this.buttonElement.setAttribute("aria-expanded", "false");
    this.buttonElement.title =" Embeber contenido";
    const iconSpan = document.createElement("span"),
      labelSpan = document.createElement("span");
    iconSpan.textContent = "Embeber contenido";
    labelSpan.className = "oculto-visual";
    labelSpan.textContent = "Embeber contenido";
    this.buttonElement.appendChild(iconSpan);
    this.buttonElement.appendChild(labelSpan);
    this.containerElement.appendChild(this.buttonElement);
  }

  buildDialog() {
    const buttonsContainer = document.createElement("div");

    this.dialogElement = document.createElement("div");
    this.dialogElement.className = "editor-dialog";
    this.dialogElement.style.positionAnchor = "--embed-anchor";
    this.urlInput = document.createElement("input");
    this.urlInput.setAttribute("placeholder", "URL");
    this.urlInput.className = "editor-input";
    //this.urlInput.required = true;
    this.urlInput.type = "text";

    this.submitButton = document.createElement("button");
    this.submitButton.type = "button";
    this.submitButton.className = "editor-button";
    this.submitButton.textContent = "Agregar";

    buttonsContainer.className = "editor-buttons-container";
    buttonsContainer.appendChild(this.submitButton);

    this.dialogElement.appendChild(this.urlInput);
    this.dialogElement.appendChild(buttonsContainer);

    this.containerElement.appendChild(this.dialogElement);
  }

  bindActions() {
    this.buttonAction = this.buttonClickCallback();
    this.submitAction = this.submitButtonClickCallback();
    this.buttonElement.addEventListener("click", this.buttonAction);
    this.submitButton.addEventListener("click", this.submitAction);
  }

  update(view) {
    const nodeAttrs = getNodeAttrs(view.state, customSchema.nodes.embed),
      isEnabled = insertEmbed(null)(view.state, null);
    if(nodeAttrs) { 
      this.urlInput.value = nodeAttrs.src;
      this.buttonElement.setAttribute("aria-pressed", "true");
    } else {
      this.urlInput.value = null;
      this.buttonElement.setAttribute("aria-pressed", "false");
    }

    this.buttonElement.disabled = !isEnabled;
  }

  destroy() {
    this.buttonElement.removeEventListener("click", this.buttonAction);
    this.submitButton.removeEventListener("submit", this.submitAction);
    this.containerElement.remove();
    this.containerElement = null;
    this.buttonElement = null;
    this.urlInput = null;
    this.submitButton = null;
    this.dialogElement = null;
    this.buttonAction = null;
    this.submitAction = null;
  }

  buttonClickCallback() {
    return () => {
      setActiveTool(this.buttonElement)(this.view.state, this.view.dispatch);
    }
  }

  submitButtonClickCallback() {
    return (event) => {
      const { value: href } = this.urlInput;

      if(!insertEmbed(null)(this.view.state, null)) {
        return false;
      }

      insertEmbed(href)(this.view.state, this.view.dispatch);
      setActiveTool(null)(this.view.state, this.view.dispatch);
      this.view.focus();
    }
  }
}
